import { MappingPage } from "Core/Pages/MappingPage";
import { ServiceProvider } from "Service";

export class IfcExportPage extends MappingPage {
    constructor(serviceProvider: ServiceProvider) {
        super("ifc_export", serviceProvider);
    }
}
